var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-box"},[_c('div',{staticClass:"loading-box-inner"},[_c('div',[_c('img',{attrs:{"src":"https://alphahr.oss-cn-beijing.aliyuncs.com/public/assets/loading2.gif","width":"100%"}})]),_c('div',[_c('div',{staticClass:"loader seven"})])])])
}]

export { render, staticRenderFns }